var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0A3887",
  clipPath: "url(#edit2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.816 4.86 30.11.183a.635.635 0 0 0-.896 0l-3.022 3.004-13.436 13.356-1.346 1.338a.66.66 0 0 0-.16.252l-2.184 6.848a.63.63 0 0 0 .8.789l6.884-2.171a.6.6 0 0 0 .254-.158l1.346-1.338L31.787 8.748l3.022-3.004a.626.626 0 0 0 0-.89zM16.224 22.45l-5.57 1.755 1.766-5.535.787-.783 3.804 3.78zm1.682-1.672-3.803-3.781 12.54-12.465 3.804 3.78zM31.342 7.422l-3.803-3.78 2.127-2.115 3.804 3.781z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.114 15.697a.635.635 0 0 0-.635.63v16.41H1.27V4.337h17.144c.35 0 .635-.284.635-.631a.635.635 0 0 0-.635-.631H.635a.635.635 0 0 0-.635.63V33.37c0 .347.286.631.635.631h30.479c.35 0 .635-.284.635-.631V16.328a.635.635 0 0 0-.635-.631"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "edit2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h35v34H0z"
})))));
export { SvgEdit2 as ReactComponent };
export default __webpack_public_path__ + "c3c38fafdfde3fd12b4205e9f064c58a.svg";